import {
  Button,
  Colors,
  Divider,
  HTMLSelect,
  Icon,
  NumericInput,
} from '@blueprintjs/core';
import '@blueprintjs/table/lib/css/table.css';
import { useTablePagingContext } from 'Components/Generic/AdvancedDataTable/DataTableComponent';
import styles from './DataTable.module.css';

const PagingFooter = () => {
  const { pagingInfo, setPagingInfo, rowCount } = useTablePagingContext();

  const jumpToPageNumber = (newPageNumber) => {
    if (newPageNumber !== pagingInfo.pageNumber) {
      setPagingInfo({ ...pagingInfo, pageNumber: newPageNumber });
    }
  };

  const increasePageNumber = () => {
    const newPageNumber = Math.min(
      pagingInfo.pageNumber + 1,
      pagingInfo.totalPages,
    );
    jumpToPageNumber(newPageNumber);
  };

  const decreasePageNumber = () => {
    jumpToPageNumber(Math.max(pagingInfo.pageNumber - 1, 1));
  };

  const getVisibleRowNumbersString = () => {
    if (rowCount <= 0) {
      return 'No results';
    }
    let firstRow = (+pagingInfo.pageNumber - 1) * +pagingInfo.pageSize + 1;
    let lastRow = firstRow + +pagingInfo.pageSize;
    lastRow = lastRow <= rowCount ? lastRow : rowCount;

    return firstRow < lastRow
      ? `${firstRow}-${lastRow} of ${rowCount}`
      : `${firstRow} of ${rowCount}`;
  };

  return (
    <div className={styles.paging_footer}>
      <div>
        Rows per page:
        <HTMLSelect
          minimal
          value={pagingInfo.pageSize}
          onChange={(e) =>
            setPagingInfo({ ...pagingInfo, pageSize: e.currentTarget.value })
          }
          options={[5, 10, 50, 150]}
        />
      </div>

      <Divider className={styles.divider} />

      <span>Showing {getVisibleRowNumbersString()}</span>

      <Divider className={styles.divider} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          columnGap: 4,
        }}>
        <Button
          minimal
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => {
            jumpToPageNumber(1);
          }}
          disabled={pagingInfo.pageNumber <= 1}>
          <Icon
            icon={'double-chevron-left'}
            color={
              pagingInfo.pageNumber <= 1 ? Colors.GRAY4 : Colors.DARK_GRAY5
            }
            size={20}
          />
        </Button>
        <Button
          minimal
          onMouseDown={(e) => e.preventDefault()}
          onClick={decreasePageNumber}
          disabled={pagingInfo.pageNumber <= 1}>
          <Icon
            icon={'chevron-left'}
            color={
              pagingInfo.pageNumber <= 1 ? Colors.GRAY4 : Colors.DARK_GRAY5
            }
            size={20}
          />
        </Button>
        Page
        <NumericInput
          style={
            pagingInfo.totalPages > 100
              ? { width: 46 }
              : pagingInfo.totalPages > 10
              ? { width: 40 }
              : { width: 30 }
          }
          allowNumericCharactersOnly
          clampValueOnBlur
          selectAllOnFocus
          min={1}
          max={pagingInfo.totalPages}
          value={pagingInfo.pageNumber}
          onValueChange={(valueAsNumber) =>
            setPagingInfo({ ...pagingInfo, pageNumber: valueAsNumber })
          }
          buttonPosition='none'
        />
        of {pagingInfo.totalPages}
        <Button
          minimal
          onMouseDown={(e) => e.preventDefault()}
          onClick={increasePageNumber}
          disabled={pagingInfo.pageNumber === pagingInfo.totalPages}>
          <Icon
            icon={'chevron-right'}
            color={
              pagingInfo.pageNumber === pagingInfo.totalPages
                ? Colors.GRAY4
                : Colors.DARK_GRAY5
            }
            size={20}
          />
        </Button>
        <Button
          minimal
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => {
            jumpToPageNumber(pagingInfo.totalPages);
          }}
          disabled={pagingInfo.pageNumber === pagingInfo.totalPages}>
          <Icon
            icon={'double-chevron-right'}
            color={
              pagingInfo.pageNumber === pagingInfo.totalPages
                ? Colors.GRAY4
                : Colors.DARK_GRAY5
            }
            size={20}
          />
        </Button>
      </div>
    </div>
  );
};

export default PagingFooter;
